import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { WorkExperienceService } from '../../../service/work-experience/work-experience.service';
import { WorkExperience } from '../../../class/work-experience';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
declare var google: any;

@Component({
  selector: 'app-work-experience',
  templateUrl: './work-experience.component.html',
  styleUrls: ['./work-experience.component.scss']
})
export class WorkExperienceComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoWorkExperience: WorkExperience;
    public workExperience: WorkExperience;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public workExperienceService: WorkExperienceService,
        private activatedRoute: ActivatedRoute,
        private mapsAPILoader: MapsAPILoader) {
    }

    ngOnInit() {
    }

    public cancelWorkExperience () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/work-experiences/work-experience/work-experience.component.ts